module.exports = __webpack_public_path__ + "img/search.09d2176c.svg";